import {Companies, RandomEvents} from "./models.js";

function Message() {

    // Integer
    const month = null;
    const year = null;

    // Strings
    const subject = null;
    const content = null;
    const fromName = null;
    const tag = null;

    // Boolean
    const read = false;
    const promptAction = false;

    // Foreign keys
    const companyId = null;
    const randomEventId = null;

    return {
        month,
        year,
        subject,
        content,
        fromName,
        tag,
        read,
        promptAction,
        companyId,
        randomEventId,
    };
}

function getMessageCompany(message) {
    return Companies.find({'$loki': message.companyId})[0];
}

function getMessageRandomEvent(message) {
    return RandomEvents.find({'$loki': message.randomEventId})[0];
}

export { Message, getMessageCompany, getMessageRandomEvent }
